var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78978 3.02117C9.08019 2.43283 9.91916 2.43283 10.2096 3.02117L11.9459 6.53884L15.83 7.10656C16.4791 7.20144 16.7378 7.99931 16.2679 8.45702L13.458 11.1938L14.121 15.0593C14.2319 15.706 13.553 16.1992 12.9722 15.8938L9.49967 14.0676L6.02713 15.8938C5.44634 16.1992 4.76745 15.706 4.87838 15.0593L5.54134 11.1938L2.73146 8.45702C2.26153 7.99931 2.52024 7.20143 3.16934 7.10656L7.05342 6.53884L8.78978 3.02117Z",
    fill: "#D9AD6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStarIcon);
export default __webpack_public_path__ + "static/media/reviewStarIcon.c1311af8b2ba67e64152dfa89e3442b7.svg";
export { ForwardRef as ReactComponent };